/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/router';
import * as i2 from '../../../../app/layouts/auth/auth-layout.component';
const styles_AuthLayoutComponent:any[] = ([] as any[]);
export const RenderType_AuthLayoutComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AuthLayoutComponent,data:{}});
export function View_AuthLayoutComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
      ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(212992,(null as any),0,i1.RouterOutlet,[i1.ChildrenOutletContexts,i0.ViewContainerRef,
          i0.ComponentFactoryResolver,[8,(null as any)],i0.ChangeDetectorRef],(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export function View_AuthLayoutComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'app-layout',([] as any[]),
      (null as any),(null as any),(null as any),View_AuthLayoutComponent_0,RenderType_AuthLayoutComponent)),
      i0.ɵdid(49152,(null as any),0,i2.AuthLayoutComponent,([] as any[]),(null as any),
          (null as any))],(null as any),(null as any));
}
export const AuthLayoutComponentNgFactory:i0.ComponentFactory<i2.AuthLayoutComponent> = i0.ɵccf('app-layout',
    i2.AuthLayoutComponent,View_AuthLayoutComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovUHJvamVjdHMvR2l0SHViL2VkdWNhdGlvbi1lZS13ZWIvc3JjL2FwcC9sYXlvdXRzL2F1dGgvYXV0aC1sYXlvdXQuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0Q6L1Byb2plY3RzL0dpdEh1Yi9lZHVjYXRpb24tZWUtd2ViL3NyYy9hcHAvbGF5b3V0cy9hdXRoL2F1dGgtbGF5b3V0LmNvbXBvbmVudC50cyIsIm5nOi8vL0Q6L1Byb2plY3RzL0dpdEh1Yi9lZHVjYXRpb24tZWUtd2ViL3NyYy9hcHAvbGF5b3V0cy9hdXRoL2F1dGgtbGF5b3V0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovUHJvamVjdHMvR2l0SHViL2VkdWNhdGlvbi1lZS13ZWIvc3JjL2FwcC9sYXlvdXRzL2F1dGgvYXV0aC1sYXlvdXQuY29tcG9uZW50LnRzLkF1dGhMYXlvdXRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+IiwiPGFwcC1sYXlvdXQ+PC9hcHAtbGF5b3V0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO2FBQUE7c0NBQUE7VUFBQTtJQUFBOzs7O29CQ0FBO01BQUE7YUFBQTtVQUFBOzs7In0=



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/$$_gendir/app/layouts/auth/auth-layout.component.ngfactory.ts